export const isNumber = (value: number | null | undefined): value is number =>
  typeof value === 'number';
